export const general_props = {
  // variant: "outlined",
  // color: "info",
  fullWidth: true,
};
